import {
  MarketingSection,
  SectionIntro,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

const STYLES = [
  { name: "Photorealistic", image: "artwork-style-photorealistic" },
  { name: "Cartoon", image: "artwork-style-cartoon" },
  { name: "Pixelated", image: "artwork-style-pixelated" },
  { name: "Polaroid", image: "artwork-style-polaroid" },
  { name: "Watercolor", image: "artwork-style-watercolor" },
];

export default function StyleComparison() {
  return (
    <MarketingSection className="bg-[linear-gradient(180deg,#fff_0%,#f7f8ff_100%)]">
      <SectionKicker>Built-in styles</SectionKicker>
      <SectionTitle>One idea. So many ways to see it.</SectionTitle>
      <SectionIntro>
        Write your prompt once, then try it across Lutely’s built-in artistic
        styles. Compare different looks, explore unexpected directions, and find
        the one that fits your music.
      </SectionIntro>
      <h3 className="m-0 mt-[38px] font-figtree text-[15px] font-black uppercase leading-[1.2] tracking-[0.1em] text-blue-600 max-[680px]:mt-[30px]">
        One prompt. Five styles.
      </h3>
      <div className="mt-4 grid grid-cols-5 gap-[15px] max-[980px]:grid-cols-3 max-[680px]:flex max-[680px]:w-[calc(100%+20px)] max-[680px]:snap-x max-[680px]:snap-mandatory max-[680px]:gap-[14px] max-[680px]:overflow-x-auto max-[680px]:pb-5 max-[680px]:pr-5 max-[680px]:pt-[2px]">
        {STYLES.map((style) => (
          <figure
            key={style.name}
            className="m-0 overflow-hidden rounded-[20px] border border-[#DFE3F1] bg-white shadow-[0_14px_35px_rgba(16,28,84,0.08)] max-[680px]:flex-[0_0_76vw] max-[680px]:snap-start"
          >
            <img
              src={`/marketing/artwork/${style.image}.webp`}
              alt={`The shared cover art prompt rendered in the ${style.name} style`}
              loading="lazy"
              className="block aspect-square w-full object-cover"
            />
            <figcaption className="px-4 pb-4 pt-[14px] font-open-sans text-[14px] font-[850] leading-[1.55] text-marketing-ink">
              {style.name}
            </figcaption>
          </figure>
        ))}
      </div>
    </MarketingSection>
  );
}
